import {
  EPICS_PATH_CANCEL,
  EPICS_PATH_CONTINUE,
  EPICS_PATH_ERROR,
  EPICS_PATH_HEALTHZ,
  EPICS_PATH_RAISE,
  EPICS_PATH_REDIRECT,
  EPICS_PATH_START,
  EPICS_PATH_TASK,
  EPICS_PATH_UID,
} from 'volto-epics-addon/constants';
import ContinuationPollPage from 'volto-epics-addon/components/theme/Epics/ContinuationPollPage';
import UnexpectedErrorPage from 'volto-epics-addon/components/theme/Epics/UnexpectedErrorPage';
import ContinuationStatus from 'volto-epics-addon/components/theme/Epics/ContinuationStatus';
import * as ed25519 from '@noble/ed25519';

const applyConfig = (config) => {
  const publicPath = (process.env.PUBLIC_PATH || '').replace(/\/$/, '');
  config.settings = {
    ...config.settings,
    nonContentRoutes: [
      ...config.settings.nonContentRoutes,
      `${publicPath}${EPICS_PATH_HEALTHZ}`,
      `${publicPath}${EPICS_PATH_CONTINUE}`,
      `${publicPath}${EPICS_PATH_CANCEL}`,
      `${publicPath}${EPICS_PATH_REDIRECT}`,
      `${publicPath}${EPICS_PATH_RAISE}`,
      new RegExp(`${publicPath}${EPICS_PATH_UID}/.*`),
      new RegExp(`${publicPath}${EPICS_PATH_TASK}/.*`),
      new RegExp(`${publicPath}${EPICS_PATH_START}/.*`),
      new RegExp(`${publicPath}${EPICS_PATH_ERROR}/.*`),
    ],
    appExtras: [
      ...config.settings.appExtras,
      {
        match: '',
        component: ContinuationStatus,
      },
    ],
    publicPath: publicPath,
    processApiPath: process.env.PROCESS_API_PATH || 'localhost:8000',
  };

  config.addonRoutes = [
    ...(config.addonRoutes || []),
    {
      path: EPICS_PATH_CONTINUE,
      component: ContinuationPollPage,
    },
    {
      path: `${EPICS_PATH_ERROR}/:uuid`,
      component: UnexpectedErrorPage,
    },
  ];

  config.addonReducers = {
    ...config.addonReducers,
  };

  if (__SERVER__) {
    const middleware = require('./middleware');
    config.settings.expressMiddleware = [
      ...config.settings.expressMiddleware,
      middleware.default(publicPath),
    ];

    const isDevelopment = process.env.NODE_ENV === 'development';
    const privateKeyHex = process.env.ED25519_PRIVATE_KEY;

    try {
      config.settings.cookiePrivateKey =
        isDevelopment && !privateKeyHex
          ? ed25519.utils.randomPrivateKey()
          : new Uint8Array(Buffer.from(privateKeyHex, 'hex'));

      ed25519
        .getPublicKey(config.settings.cookiePrivateKey)
        .then((publicKey) => {
          config.settings.cookiePublicKey = publicKey;
        })
        .catch((error) => {
          console.error('Could not generate public key for ed25519:', error);
        });
    } catch (error) {
      console.error('Could not set up private key for ed25519:', error);
    }
  }
  return config;
};

export default applyConfig;
